import React from 'react';
import { FixedSizeList as List } from 'react-window';
import ChannelRow from './ChannelRow';

const ChannelList = ({ channels, channelListRef, onScroll }) => (
    <List
        height={window.innerHeight - 100} // Adjust as necessary
        itemCount={channels.length}
        itemSize={50} // Adjust as necessary
        width={300}
        ref={channelListRef}
        onScroll={({ scrollOffset }) => onScroll(scrollOffset)}
        style={{
            overflowX: 'hidden', // Hide the horizontal scrollbar
            overflowY: 'scroll', // Keep vertical scrolling active
            scrollbarWidth: 'none', // Hide scrollbar for Firefox
        }}
    >
        {({ index, style }) => (
            <ChannelRow index={index} style={style} channels={channels} />
        )}
    </List>
);

export default ChannelList;
